import { BaseApi } from "services/api/base";
import ViewSerializer from "services/api/customView/CustomViewSerializer";
import { ICustomView } from "store/entities/custom-views/interfaces";

export default class CustomViewApi extends BaseApi {
  protected readonly prefix = "views";

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  create = (customView: Partial<ICustomView>) => this.post("", ViewSerializer.serialize(customView));
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  update = (customView: Partial<ICustomView>) => this.patch(customView.id, ViewSerializer.serialize(customView));

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deleteCustomView = (viewId: string) => this.delete(viewId);

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetch = (viewId: string) => this.get(viewId);
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchAll = () => this.get();
}
